import Service from 'react-reservice';

import getCountryDetailsAPI, { ICountryDetail } from '@webtrader/core/api/account/country';
import getCountryStoneinnoDetailsAPI, { ICountryStoneinnoDetail } from '@webtrader/core/api/account/country-stoneinno';

interface ICountryContext {
  loading: boolean;
  countryDetails: ICountryDetail[];
  countryStoneinnoDetails: ICountryStoneinnoDetail[];
}

const defaultContext: ICountryContext = {
  loading: true,
  countryDetails: [],
  countryStoneinnoDetails: []
};

class CountryService extends Service<ICountryContext> {
  constructor() {
    super();

    this.context = {
      ...defaultContext
    };
  }

  public init = (isStoneinno?: boolean) => {
    this.retrieveAllCountries(isStoneinno);
  };

  public reset = () => {
    this.context.loading = false;
    this.context.countryDetails = [];
  };

  public getCountryDialCode = (selectedCountry: string) => {
    const selectedCountryDetails = this.context.countryDetails.find(
      (countryDetails) => countryDetails.country === selectedCountry
    );
    return selectedCountryDetails?.dialCode ?? '';
  };

  private retrieveAllCountries = async (isStoneinno?: boolean) => {
    try {
      this.context.loading = true;
      const { result } = isStoneinno ? await getCountryStoneinnoDetailsAPI() : await getCountryDetailsAPI();

      if (result) {
        if (isStoneinno) {
          this.context.countryStoneinnoDetails = result as ICountryStoneinnoDetail[];
        } else {
          this.context.countryDetails = result;
        }
      }
    } catch (e) {
      // console.log('Unable to fetch countries:', e);
    } finally {
      this.context.loading = false;
    }
  };
}

export default new CountryService();
